export default __webpack_public_path__ + "sync-classlink.png";